import { Theme, css } from '@emotion/react';

export const layoutSpacing = ({ spacing }: Theme) => css`
  display: grid;
  gap: ${spacing(2)}px;
`;
